import { Injectable, Inject } from '@angular/core';
import { LogService, NotificationService } from '@ridango/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SwishState } from './store/swish.store';
import { NgRedux } from '@angular-redux/store';
import { SwishActions } from './+state/swish.actions';

@Injectable()
export class SwishService {

    constructor(
        @Inject( 'ENV' ) private env: any,
        private ls: LogService,
        private http: HttpClient,
        private notifications: NotificationService,
        private ngRedux: NgRedux<SwishState>,
        private actions: SwishActions,

    ) { }

    startSwishPayment ( cartId, paymentId, msisdn ): Observable<any> {
        // v2/{region_id}/swish/cart/{cart_id}/payment/{payment_id}/payer/{msisdn}
        const payload = {};
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/swish/cart/${cartId}/payment/${paymentId}/payer/${msisdn}`;
        return this.http.post( url, payload );
    }
    getPaymentStatus ( cartId, paymentId ): Observable<HttpResponse<any>> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/swish/cart/${cartId}/payment/${paymentId}/status`;
        return this.http.get( url, { observe: 'response' } );
    }
    setTransactionData( data ) {
        this.ngRedux.dispatch( this.actions.setTransactionData( data ) );
    }
    setTransactionStatus(status) {
        this.ngRedux.dispatch(this.actions.setTransactionStatus(status));
    }

}
